import { Box, Paper, Typography, styled } from "@material-ui/core";

export const CardsContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
  gap: "0.75rem",
  minWidth: 0,
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
  }
}));

export const StyledCardContent = styled(Paper)({
  display: "flex",
  alignItems: "center",
  gap: "0.9rem",
  minHeight: "4.2rem",
  minWidth: 0,
  padding: "0.75rem 1rem",
  background: "#FFF",
  border: "1px solid #E5E7EB",
  borderRadius: "0.5rem",
  boxShadow: "0 6px 16px rgba(17, 24, 39, 0.035)"
});

export const IconContent = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: "2.45rem",
  height: "2.45rem",
  borderRadius: "0.5rem"
});

export const InfoContent = styled(Box)({
  display: "flex",
  minWidth: 0,
  flexDirection: "column",
  gap: "0.3rem"
});

export const CardTitle = styled(Typography)({
  color: "#4B5563",
  fontFamily: "Inter",
  fontSize: "0.75rem",
  fontWeight: 500,
  lineHeight: 1.25,
  wordWrap: "break-word"
});

export const CardValue = styled(Typography)({
  color: "#111827",
  fontFamily: "Inter",
  fontSize: "1.25rem",
  fontWeight: 800,
  lineHeight: 1,
  wordWrap: "break-word"
});

export const BreakageCardContent = styled(Paper)({
  display: "flex",
  alignItems: "center",
  gap: "0.9rem",
  minHeight: "4.2rem",
  minWidth: 0,
  background: "#FFF",
  border: "1px solid #DCE8D2",
  borderTop: "0.25rem solid #416D0B",
  borderRadius: "0.5rem",
  boxShadow: "0 6px 16px rgba(17, 24, 39, 0.035)",
  padding: "0.75rem 1rem",
  overflow: "hidden"
});

export const BreakageInfoContent = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "0.3rem",
  flex: 1,
  minWidth: 0
});

export const BreakageCardValueRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "0.2rem 0.5rem"
});

export const BreakageDetailsButton = styled("button")({
  display: "inline-flex",
  alignItems: "center",
  gap: "0.3rem",
  background: "none",
  border: "none",
  padding: 0,
  color: "#416D0B",
  cursor: "pointer",
  fontFamily: "Inter",
  fontSize: "0.75rem",
  fontWeight: 600,
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "underline"
  }
});
